export function importBundle(bundleUrl) {
  // babel is giving me guff about dynamic importing
  // from a variable, which we need since the CDN changes
  // for staging and prod. We have to do this hack to please
  // the babel overlords for the time being

  // eslint-disable-next-line no-eval
  return eval(`import('${bundleUrl}')`);
}